<div class="section" *ngIf="hasContent || editModeSet">
  <div class="section__header">
    <h2 class="section__header-text">Maintenance</h2>
  </div>
  <div class="section__body">
    <div class="data-block data-block--shaded-labels">
      <div *ngIf="interiorTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isRegionalManager">Interior:
          <mat-icon (click)="openEditMaintenanceDialog(['Maintenance::Interior::'], null, 'Interior')" *ngIf="editModeSet && !isRegionalManager"
            class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list *ngIf="interiorTags.length" [items]="interiorTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !interiorTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="exteriorTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isRegionalManager">Exterior:
          <mat-icon (click)="openEditMaintenanceDialog(['Maintenance::Exterior::'], null, 'Exterior')" *ngIf="editModeSet && !isRegionalManager"
            class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list *ngIf="exteriorTags.length" [items]="exteriorTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !exteriorTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="airframeTags.length || airframeManufacturerTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isRegionalManager">Airframe:
          <mat-icon (click)="openEditMaintenanceDialog(['Maintenance::Airframe::'], ['Maintenance::Airframe::Manufacturers::'], 'Airframe')"
            *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list *ngIf="airframeTags.length" [items]="airframeTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !airframeTags.length">
            <p>None Selected</p>
          </div>

          <div *ngIf="airframeManufacturerTags.length || editModeSet" class="business-maintenance__sublist">
            <h4>Manufacturers Supported: <mat-icon (click)="openEditMaintenanceDialog(['Maintenance::Airframe::Manufacturers::'], null, 'Airframe Manufacturers')"
              *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon> </h4>
            <app-tag-bullet-list *ngIf="airframeManufacturerTags.length" [items]="airframeManufacturerTags"></app-tag-bullet-list>
            <div *ngIf="editModeSet && !airframeManufacturerTags.length">
              <p>None Selected</p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="powerplantTags.length || powerplantManufacturerTags.length || editModeSet " class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isRegionalManager">Powerplant:
          <mat-icon (click)="openEditMaintenanceDialog(['Maintenance::Powerplant::'], ['Maintenance::Powerplant::Manufacturers::'], 'Powerplant')"
            *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list *ngIf="powerplantTags.length" [items]="powerplantTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !powerplantTags.length">
            <p>None Selected</p>
          </div>
          <div *ngIf="powerplantManufacturerTags.length || editModeSet" class="business-maintenance__sublist">
            <h4>Manufacturers Supported: <mat-icon (click)="openEditMaintenanceDialog(['Maintenance::Powerplant::Manufacturers::'], ['Maintenance::Powerplant::Manufacturers::FAA Repair'], 'Powerplant Manufacturers')"
              *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon></h4>
            <app-tag-bullet-list *ngIf="powerplantManufacturerTags.length" [items]="powerplantManufacturerTags"></app-tag-bullet-list>
            <div *ngIf="editModeSet && !powerplantManufacturerTags.length">
              <p>None Selected</p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="propellerTags.length || propellerManufacturerTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isRegionalManager">Propeller/Rotor Blades:
          <mat-icon (click)="openEditMaintenanceDialog(['Maintenance::Propeller::', 'Maintenance::Rotor::'], ['Maintenance::Propeller::Manufacturers::'], 'Propeller/Rotor Blades')"
            *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list *ngIf="propellerTags.length" [items]="propellerTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !propellerTags.length">
            <p>None Selected</p>
          </div>
          <div *ngIf="propellerManufacturerTags.length || editModeSet" class="business-maintenance__sublist">
            <h4>Manufacturers Supported: <mat-icon (click)="openEditMaintenanceDialog(['Maintenance::Propeller::Manufacturers::'], null , 'Propeller Manufacturers')"
              *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon> </h4>
            <app-tag-bullet-list *ngIf="propellerManufacturerTags.length" [items]="propellerManufacturerTags"></app-tag-bullet-list>
            <div *ngIf="editModeSet && !propellerManufacturerTags.length">
              <p>None Selected</p>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="avionicsTags.length || avionicsManufacturerTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label" [class.data-block__label__override]="editModeSet && !isRegionalManager">Radio and Avionics:
          <mat-icon (click)="openEditMaintenanceDialog(['Maintenance::Avionics::'], ['Maintenance::Avionics::Manufacturers::'] , 'Radio and Avionics')"
            *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list *ngIf="avionicsTags.length" [items]="avionicsTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !avionicsTags.length">
            <p>None Selected</p>
          </div>
          <div *ngIf="avionicsManufacturerTags.length || editModeSet" class="business-maintenance__sublist">
            <h4>Manufacturers Supported: <mat-icon (click)="openEditMaintenanceDialog(['Maintenance::Avionics::Manufacturers::'], null , 'Avionics Manufacturers')"
              *ngIf="editModeSet && !isRegionalManager" class="edit-icon">edit</mat-icon></h4>
            <app-tag-bullet-list *ngIf="avionicsManufacturerTags.length" [items]="avionicsManufacturerTags"></app-tag-bullet-list>
            <div *ngIf="editModeSet && !avionicsManufacturerTags.length">
              <p>None Selected</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
